/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as CodePreviewLoading } from './code-preview-loading.story';
export { default as CodePreviewRead } from './code-preview-read.story';
export { default as CodePreviewWrite } from './code-preview-write.story';
export { default as CodePreviewLanguages } from './code-preview-languages.story';

import { removeLicenseHeader } from '../../../_common/export-stories-utils';
import CodePreviewLanguagesSourceRaw from './code-preview-languages.story?raw';
import CodePreviewLoadingSourceRaw from './code-preview-loading.story?raw';
import CodePreviewReadSourceRaw from './code-preview-read.story?raw';
import CodePreviewWriteSourceRaw from './code-preview-write.story?raw';

export const CodePreviewLoadingSource = removeLicenseHeader(
  CodePreviewLoadingSourceRaw,
);
export const CodePreviewReadSource = removeLicenseHeader(
  CodePreviewReadSourceRaw,
);
export const CodePreviewWriteSource = removeLicenseHeader(
  CodePreviewWriteSourceRaw,
);
export const CodePreviewLanguagesSource = removeLicenseHeader(
  CodePreviewLanguagesSourceRaw,
);
